import React, { useEffect, useRef, useState } from "react";
import { useAppContext } from "../context/AppContext";
import { ChatbotTrans } from "../utils/translations";

function ChatbotModal({ isOpen, onClose }) {
  const modalRef = useRef(null);
  const [messages, setMessages] = useState([]);
  const [userInput, setUserInput] = useState("");
  const { language } = useAppContext();

  // Close modal on outside click
  useEffect(() => {
    function handleClickOutside(event) {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    }

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const handleSendMessage = (e) => {
    e.preventDefault();
    if (userInput.trim()) {
      const newMessage = { text: userInput, sender: "user" };
      setMessages([...messages, newMessage]);
      setUserInput("");
      
      // Simulate chatbot response
      setTimeout(() => {
        const botResponse = { text: ChatbotTrans[language].defaultResponse, sender: "bot" };
        setMessages((prevMessages) => [...prevMessages, botResponse]);
      }, 1000);
    }
  };

  return (
    <div className="fixed inset-0 z-50 bg-transparent text-left">
      <div
        ref={modalRef}
        className="absolute bottom-16 right-10 bg-white p-6 rounded-lg shadow-lg w-80"
      >
        <div className="mb-4 h-64 overflow-y-auto border border-gray-300 rounded-md p-2">
          {messages.map((message, index) => (
            <div
              key={index}
              className={`mb-2 ${
                message.sender === "user" ? "text-right" : "text-left"
              }`}
            >
              <p
                className={`inline-block p-2 rounded-lg ${
                  message.sender === "user"
                    ? "bg-blue-500 text-white"
                    : "bg-gray-200 text-black"
                }`}
              >
                {message.text}
              </p>
            </div>
          ))}
        </div>
        <form onSubmit={handleSendMessage} className="flex items-center">
          <input
            type="text"
            value={userInput}
            onChange={(e) => setUserInput(e.target.value)}
            className="border rounded-md p-2 w-full"
            placeholder={ChatbotTrans[language].inputPlaceholder}
          />
          <button
            type="submit"
            className="font-semibold text-sm bg-pink transition-colors rounded-3xl text-white text-md py-1 px-4 ml-2 w-fit"
          >
            {ChatbotTrans[language].sendButton}
          </button>
        </form>
      </div>
    </div>
  );
}

export default ChatbotModal;
